
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/utils/utils"
import { Text } from "./text"
import { styleDrivers } from "@/utils/componentStyle"

const badgeVariants = cva(styleDrivers.badge.root, {
  variants: {
    variant: styleDrivers.badge.variants,
    size: {
      default: "",
      sm: "px-2 py-0.5 text-[10px]",
      lg: "px-4 py-1.5 text-sm",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
})

type BadgeProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof badgeVariants>

function Badge({ className, variant, size, children, ...props }: BadgeProps) {
  return (
    <div
      data-slot="badge"
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    >
      {typeof children === "string" || typeof children === "number" ? (
        <Text as="p">{children}</Text>
      ) : (
        children
      )}
    </div>
  )
}

export { Badge, badgeVariants }